import React,{ useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Table from 'react-bootstrap/Table';

function DriverListModal({visible,onHide,title,driverList,setSelectedDriverId,selectedDriverId,onSave,isClicked}) {
    

    const handleRadioChange = (userId) => {
        setSelectedDriverId(userId);
    };
  return (
    <Dialog header={title} visible={visible} onHide={onHide}>
    <form>
        <div style={{ width: "34em" }}>
        <Table striped bordered hover className='tbl-require'>
      <thead>
        <tr>
          <th>#</th>
          <th>SLNo.</th>
          <th>Driver Name</th>
          {/* <th>Driver Address</th> */}
          <th>UMPI Number</th>
        </tr>
      </thead>
      <tbody>
        {driverList && driverList.map((details, index) => {
          
          
          return (
            <tr key={details?.user_id}>
              <td>
                <input
                  type="radio"
                  name="driver"
                  value={details?.user_id}
                  checked={selectedDriverId === details?.user_id}
                  onChange={() => handleRadioChange(details?.user_id)}
                  />
               </td>
              <td>{ index + 1}</td>
              <td>{(details.first_name && details.last_name) ? (details?.first_name + ' ' + details?.middle_name + ' ' + details?.last_name) : details?.full_name}</td>
              {/* <td>{details ? (details?.address1 + ' ' + 
                details?.address2 + ' ' + 
                details?.city + ' ' + 
                details?.state_list?.state_name + ' ' +
                details?.zip) : ''}</td> */}
              <td>{details.driver?.umpi_no}</td>
              
              
            </tr>
          );
})}
      </tbody>
    </Table>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
            <button
                style={{
                    marginRight: "9px",
                    width: "9em",
                    backgroundColor: '#328277',
                    color: "#fff",
                    border: "none",
                    padding: "7px"
                }}
                type="button"
                onClick={onSave}
                disabled={isClicked}
            >
               {isClicked ? 'Processing..' : 'ASSIGN'} 
            </button>
            <button
                style={{
                    width: "9em",
                    backgroundColor: '#f9ae3b',
                    color: "#fff",
                    border: "none"
                }}
                type="button"
                onClick={onHide}
            >
                CLOSE
            </button>
        </div>
    </form>
</Dialog>
  )
}

export default DriverListModal